import { TournamentReward } from 'config/types/tournament'
import { useMemo } from 'react'
import styled from 'styled-components'
import { colors } from 'theme/colors'
import Box from 'UIKit/Box/Box'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'

enum TopRankEnum {
  FirstRank,
  SecondRank,
  ThirdRank,
}

const DisplayRank: React.FC<{ rank: number; prize: TournamentReward; isActive?: boolean }> = ({
  rank,
  prize,
  isActive,
}) => {
  const rankImageSrc = useMemo(() => {
    switch (Number(rank)) {
      case TopRankEnum.FirstRank:
        return '/images/tournament/1st-prize.png'
      case TopRankEnum.SecondRank:
        return '/images/tournament/2nd-prize.png'
      case TopRankEnum.ThirdRank:
        return '/images/tournament/3rd-prize.png'
      default:
        break
    }
  }, [rank])

  return (
    <Box position="relative" left="-4px">
      {Object.values(TopRankEnum).includes(rank) ? (
        <Image src={rankImageSrc} width={24} height={24} />
      ) : (
        <DisplayText color={prize && !isActive ? `${colors.textAlt1} !important` : 'text'} fontWeight={600}>
          {prize ? Number(rank + 1) : '_'}
        </DisplayText>
      )}
    </Box>
  )
}

const DisplayText = styled(Text)`
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.24px;
  color: ${({ theme: { colors } }) => colors.textTertiary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default DisplayRank
